module.exports = __webpack_public_path__ + "static/media/9.d076edd1.jpg";